import Layout from '../components/Layout';
import DepositForm from '../components/DepositForm';

const TopUp = () => {
  return (
    <Layout>
      <div className="relative grid min-h-[calc(100vh-8rem)] lg:min-h-[calc(100vh-4rem)] place-items-center">
        <div className="absolute inset-0 rounded-3xl backdrop-blur-md animate-enterUp" />
        <div className="relative mx-auto w-full max-w-3xl px-4">
          <div className="animate-enterZoom" style={{ animationDelay: '80ms' }}>
            <DepositForm />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TopUp;